import { Box, Container, Typography, Grid, Link as JoyLink } from '@mui/joy';
import { Link } from 'react-router-dom';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import GavelIcon from '@mui/icons-material/Gavel';
import SecurityIcon from '@mui/icons-material/Security';
import CancelIcon from '@mui/icons-material/Cancel';
import ReceiptIcon from '@mui/icons-material/Receipt';
import BlockIcon from '@mui/icons-material/Block';
import HomeIcon from '@mui/icons-material/Home';
import InfoIcon from '@mui/icons-material/Info';
import WorkIcon from '@mui/icons-material/Work';
import logo from '../../assets/logo.png';
import wording_logo from '../../assets/wording_logo.png';


const Footer = () => {
    return (
        <Box 
        component="footer" 
        sx={{ 
            py: 8,
            mt: 'auto',
            bgcolor: 'background.level1',
            borderTop: '1px solid',
            borderColor: 'divider'
        }}
        >
            <Container>
                <Grid container spacing={4}>
                    <Grid xs={12} md={3}>
                        <img src={logo} alt="logo" style={{ width: 50, height: 50 }} />&nbsp;<img src={wording_logo} alt="logo" style={{ width: 150, height: 50 }} />
                        <Typography 
                            level="body2" 
                            mb={2}
                            sx={{ color: 'text.secondary' }}
                        >
                            Transforming fitness and lifestyle management through AI-powered solutions and seamless integrations.
                        </Typography>
                        {/* <Box sx={{ display: 'flex', gap: 1 }}>
                            <IconButton 
                                variant="plain" 
                                component="a" 
                                href="https://facebook.com"
                                sx={{ color: 'text.secondary' }}
                            >
                                <FacebookIcon />
                            </IconButton>
                            <IconButton variant="plain" component={Link} href="https://twitter.com">
                                <TwitterIcon />
                            </IconButton>
                            <IconButton variant="plain" component={Link} href="https://linkedin.com">
                                <LinkedInIcon />
                            </IconButton>
                            <IconButton variant="plain" component={Link} href="https://instagram.com">
                                <InstagramIcon />
                            </IconButton>
                        </Box> */}
                    </Grid>

                    <Grid xs={12} md={3}>
                        <Typography 
                            level="h6" 
                            mb={2}
                            sx={{ color: 'text.primary' }}
                        >
                            Legal
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                            <JoyLink 
                                component={Link} 
                                to="/terms"
                                sx={{ 
                                    color: 'text.secondary',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1,
                                    '&:hover': {
                                        color: 'primary.main'
                                    }
                                }}
                            >
                                <GavelIcon sx={{ fontSize: 20 }} />
                                Terms of Service
                            </JoyLink>
                            <JoyLink 
                                component={Link} 
                                to="/privacy"
                                sx={{ 
                                    color: 'text.secondary',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1,
                                    '&:hover': {
                                        color: 'primary.main'
                                    }
                                }}
                            >
                                <SecurityIcon sx={{ fontSize: 20 }} />
                                Privacy Policy
                            </JoyLink>
                            <JoyLink 
                                component={Link} 
                                to="/terms/cancellation"
                                sx={{ 
                                    color: 'text.secondary',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1,
                                    '&:hover': {
                                        color: 'primary.main'
                                    }
                                }}
                            >
                                <CancelIcon sx={{ fontSize: 20 }} />
                                Cancellation Policy
                            </JoyLink>
                            <JoyLink 
                                component={Link} 
                                to="/terms/refund"
                                sx={{ 
                                    color: 'text.secondary',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1,
                                    '&:hover': {
                                        color: 'primary.main'
                                    }
                                }}
                            >
                                <ReceiptIcon sx={{ fontSize: 20 }} />
                                Refund Policy
                            </JoyLink>
                            <JoyLink 
                                component={Link} 
                                to="/terms/use_restrictions"
                                sx={{ 
                                    color: 'text.secondary',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1,
                                    '&:hover': {
                                        color: 'primary.main'
                                    }
                                }}
                            >
                                <BlockIcon sx={{ fontSize: 20 }} />
                                Use Restrictions
                            </JoyLink>
                        </Box>
                    </Grid>

                    <Grid xs={12} md={3}>
                        <Typography 
                            level="h6" 
                            mb={2}
                            sx={{ color: 'text.primary' }}
                        >
                            Quick Links
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                            <JoyLink 
                                component={Link} 
                                to="/"
                                sx={{ 
                                    color: 'text.secondary',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1,
                                    '&:hover': {
                                        color: 'primary.main'
                                    }
                                }}
                            >
                                <HomeIcon sx={{ fontSize: 20 }} />
                                Home
                            </JoyLink>
                            <JoyLink 
                                component={Link} 
                                to="/about"
                                sx={{ 
                                    color: 'text.secondary',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1,
                                    '&:hover': {
                                        color: 'primary.main'
                                    }
                                }}
                            >
                                <InfoIcon sx={{ fontSize: 20 }} />
                                About
                            </JoyLink>
                            <JoyLink 
                                component={Link} 
                                to="/careers"
                                sx={{ 
                                    color: 'text.secondary',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1,
                                    '&:hover': {
                                        color: 'primary.main'
                                    }
                                }}
                            >
                                <WorkIcon sx={{ fontSize: 20 }} />
                                Careers
                            </JoyLink>
                            {/* <JoyLink 
                                component={Link} 
                                to="/about/our-work"
                                sx={{ 
                                    color: 'text.secondary',
                                    '&:hover': {
                                        color: 'primary.main'
                                    }
                                }}
                            >
                                Our Work
                            </JoyLink> */}
                        </Box>
                    </Grid>

                    <Grid xs={12} md={3}>
                        <Typography 
                            level="h6" 
                            mb={2}
                            sx={{ color: 'text.primary' }}
                        >
                            Contact Us
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                                <EmailIcon sx={{ color: 'text.secondary' }} />
                                <Typography 
                                    level="body2"
                                    sx={{ color: 'text.secondary' }}
                                >
                                    hi@hubitable.com
                                </Typography>
                            </Box>
                            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                                <PhoneIcon />
                                <Typography 
                                    level="body2"
                                    sx={{ color: 'text.secondary' }}
                                >
                                    +44 7 403624655
                                </Typography>
                            </Box>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                                    <LocationOnIcon sx={{ color: 'text.secondary' }} />
                                    <Typography 
                                        level="body2"
                                        sx={{ color: 'text.secondary' }}
                                    >
                                        86-90 Paul Street, London,<br/> Greater London, England,<br/> EC2A 4NE
                                    </Typography>
                                </Box>
                                <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                                    <LocationOnIcon sx={{ color: 'text.secondary' }} />
                                    <Typography 
                                        level="body2"
                                        sx={{ color: 'text.secondary' }}
                                    >
                                        7th floor Purshottam Place, Westlands Rd, Museum Hill,<br/> Nairobi, Kenya
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>
                    </Grid>

                    
                </Grid>

                <Box sx={{ 
                    mt: 8, 
                    pt: 2, 
                    borderTop: '1px solid', 
                    borderColor: 'divider' 
                }}>
                    <Typography 
                        textAlign="center" 
                        level="body2"
                        sx={{ color: 'text.secondary' }}
                    >
                        © {new Date().getFullYear()} Hubitable. All rights reserved.
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
};

export default Footer; 